import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface PreferencesState {
  /** Visible column keys per index page id. Missing = use the page defaults. */
  columns: Record<string, string[]>;
  recentSearches: string[];
}

const initialState: PreferencesState = { columns: {}, recentSearches: [] };
const MAX_RECENT = 5;

export const preferencesSlice = createSlice({
  name: 'preferences',
  initialState,
  reducers: {
    setVisibleColumns: (state, action: PayloadAction<{ pageId: string; columns: string[] }>) => {
      state.columns[action.payload.pageId] = action.payload.columns;
    },
    resetColumns: (state, action: PayloadAction<string>) => {
      delete state.columns[action.payload];
    },
    addRecentSearch: (state, action: PayloadAction<string>) => {
      const term = action.payload.trim();
      if (!term) return;
      state.recentSearches = [term, ...state.recentSearches.filter((s) => s !== term)].slice(
        0,
        MAX_RECENT,
      );
    },
  },
  selectors: {
    selectRecentSearches: (state) => state.recentSearches,
    selectVisibleColumns: (state, pageId: string) => state.columns[pageId],
  },
});

export const { setVisibleColumns, resetColumns, addRecentSearch } = preferencesSlice.actions;
export const { selectRecentSearches, selectVisibleColumns } = preferencesSlice.selectors;
